const isMicrofront = () => {
  const content = document.getElementById('ClubAdminApp');

  return !content;
};

export { isMicrofront };
